// extracted by mini-css-extract-plugin
export var callCard = "_n0-0";
export var callMessageButton = "_n0-1";
export var helpIcon = "_n0-3";
export var helpIconContainer = "_n0-4";
export var verticalDivider = "_n0-2";